import { Box, Flex, Spacer } from '@chakra-ui/react';
import OrderBookType from 'enums/shared/orderBookType';
import { FC } from 'react';
import OrderBookCharts from './OrderBookCharts';
import OrderBookTable from './OrderBookTable';

interface Props {
  data: OrderBook;
}

const OrderBookSection: FC<Props> = ({ data }) => {
  return (
    <Box w="100%">
      <OrderBookCharts data={data} />
      <Spacer h="10px"/>
      <Flex>
        <OrderBookTable items={data.buy} type={OrderBookType.Buy} />
        <Spacer w="20px" maxW="20px"/>
        <OrderBookTable items={data.sell} type={OrderBookType.Sell} />
      </Flex>
    </Box>
  );
};

export default OrderBookSection;
